class Drawer {
    constructor(trigger) {
        const target = document.querySelector('#' + trigger.dataset.drawerToggle);

        trigger.addEventListener('click', () => {
            target.classList.toggle('translate-y-full');
            target.classList.toggle('bottom-[60px]');
        });
    }
}

function initDrawers() {
    for (const trigger of document.querySelectorAll('[data-drawer-toggle]')) {
        const drawer = new Drawer(trigger);
    }
}

initDrawers();
